/* A text design's settings (no font code here, so the main bundle stays small:
   the fonts and the outliner load with the Add text panel).
   0.3d: the settings are saved with the gangsheet (design.text) on the server, so a text design can be
   edited again after a refresh, on another device, or (later) after recovering an account. Text
   designs made before 0.3d kept them only in the browser; those are read from there and copied into
   the gangsheet when it opens. */

import type { Design, TextSpec } from '@gsb/core';
export type { TextSpec };

export const DEFAULT_TEXT: TextSpec = {
  text: '', font: 'montserrat-800', color: '#0B1220', align: 'center', letterSpacing: 0, lineHeight: 1.1,
  outline: false, outlineColor: '#FFFFFF', outlineWidth: 4, widthMm: 250
};

/* the copy this browser kept before 0.3d (also written still, so an older tab keeps working) */
const KEY = 'gsb:text:';
export function saveTextSpec(designId: string, spec: TextSpec) { try { localStorage.setItem(KEY + designId, JSON.stringify(spec)); } catch { /* ignore */ } }
function legacyTextSpec(designId: string): TextSpec | null {
  try { const r = localStorage.getItem(KEY + designId); return r ? { ...DEFAULT_TEXT, ...JSON.parse(r) } : null; } catch { return null; }
}

/** The settings behind a text design: from the gangsheet, else from this browser (older text designs). */
export function textSpecOf(design: Pick<Design, 'id' | 'text'> | undefined | null): TextSpec | null {
  if (!design) return null;
  if (design.text) return { ...DEFAULT_TEXT, ...design.text };
  return legacyTextSpec(design.id);
}
